import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';
import BundledArtifact from './default-data/recent-work-service-artifact';
var RECENT_WORK_ARTIFACT = 'recent-work-service';
var FD_ENVIRONMENT = 'prod';
export var FD_CLIENT_FETCH_PROPS = {
  name: RECENT_WORK_ARTIFACT,
  dimensions: {
    environmentType: FD_ENVIRONMENT
  }
};
var HydratorConfigClient = /*#__PURE__*/function () {
  function HydratorConfigClient(handlers, product, artifactFetch) {
    var _this = this;
    _classCallCheck(this, HydratorConfigClient);
    _defineProperty(this, "fetchConfig", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var artifact, fragments, hydrators;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.fetchArtifact();
          case 2:
            artifact = _context.sent;
            fragments = artifact.queryFragments, hydrators = artifact.hydrators;
            return _context.abrupt("return", {
              fragments: fragments,
              hydrators: hydrators
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    this.flightDeck = new FlightDeckClient(product || 'recent-work-client', {
      handlers: handlers
    }, [{
      name: 'recent-work-service',
      dimensions: {
        environmentType: FD_ENVIRONMENT
      },
      value: BundledArtifact
    }]);
    this.artifactFetch = artifactFetch;
  }
  _createClass(HydratorConfigClient, [{
    key: "fetchArtifact",
    value: function () {
      var _fetchArtifact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.artifactFetch) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this.artifactFetch());
            case 2:
              return _context2.abrupt("return", this.flightDeck.fetchConfigFromFlightDeck(FD_CLIENT_FETCH_PROPS,
              // Retries are for the background refresh, so not too aggressive
              {
                intervalsMS: [100, 500]
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchArtifact() {
        return _fetchArtifact.apply(this, arguments);
      }
      return fetchArtifact;
    }()
  }]);
  return HydratorConfigClient;
}();
export { HydratorConfigClient as default };